import { m } from "@nerves/i18n/messages";
import { Warning } from "@phosphor-icons/react";
import { type ErrorComponentProps, useRouter } from "@tanstack/react-router";
import { Button, EmptyState } from "@/components/ui";

export function RouteError({ error }: ErrorComponentProps) {
  const router = useRouter();
  console.error(error);
  return (
    <div role="alert" className="flex flex-1 items-start justify-center p-8">
      <EmptyState
        icon={Warning}
        title={m.error_title()}
        description={m.error_body()}
        action={
          <Button variant="primary" onPress={() => void router.invalidate()}>
            {m.common_retry()}
          </Button>
        }
      />
    </div>
  );
}
